<template>
  <header-title />
  <div class="container">
    <aside-body />
    <div class="main">
      <div class="row-in-line">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="max-width: 400px; margin-left: 20px"
          :disabled-date="disabledDate"
          @change="_getTimePerson()"
        />
        <el-button
          type="warning"
          round
          style="margin-left: 20px"
          @click="_delTime"
          >清空</el-button
        >
      </div>
      <div class="row-in-line">
        <el-card style="width: 480px" shadow="always">
          <div>总计整站在线人数</div>
          <div>{{ info.countAllInWeb }}</div>
        </el-card>
        <el-card style="width: 480px" shadow="always">
          <div>总计提交问卷人数</div>
          <div>{{ info.recordCount }}</div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import headerTitle from '@/components/headerTitle.vue'
import asideBody from '@/components/asideBody.vue'
import http from '@/util/http'
import { timestampToDate } from '@/util/timeToTranser'
import Cookies from 'js-cookie'
export default {
  name: 'visitsView',
  components: { asideBody, headerTitle },
  data() {
    return {
      info: {},
      value1: [],
      time: [],
      queryData: {
        startTime: undefined,
        endTime: undefined
      }
    }
  },
  setup() {
    return {}
  },
  mounted() {
    this._getPersons()
  },
  methods: {
    _getPersons() {
      http.get('selAllPeople/').then(res => {
        if (res.code === 200) {
          this.info = res.data
        }
      })
      // if (this.value1.length === 1) {
      //   ElMessage.warning('请选择起止时间')
      //   return
      // }
      // if (this.value1.length === 2) {
      //   this.queryData.startTime = this.value1[0]
      //   this.queryData.endTime = this.value1[1]
      //   http.get('selAllPeople/', this.queryData).then(res => {
      //     console.log('返回人数', res)
      //     if (res.code === 200) {
      //       this.info = res.data
      //     }
      //   })
      // http.get('selNumCount/', this.queryData).then(res => {
      //   // 确保startDate和endDate都有值
      //   if (this.queryData.startTime && this.queryData.endTime) {

      //  const start = this.queryData.startTime.getTime()
      //  const end = this.queryData.endTime.getTime()
      //     // 禁用小于startDate或大于endDate的日期
      //     return date < startTime || date > endTime
      //   }
      //   // 如果没有具体的禁用逻辑，可以默认不禁用任何日期，这里作为示例直接返回false
      //   return false
      // })
    },
    _getTimePerson() {
      console.log(this.value1)
      if (this.value1 && this.value1.length > 0) {
        this.queryData.startTime = String(Math.floor(this.value1[0].getTime()))
        this.queryData.endTime = String(Math.floor(this.value1[1].getTime()))
        http.get('selNumCount/', this.queryData).then(res => {
          if (res.code == 200) {
            this.info = res.data
          }
        })
      } else {
        this._getPersons()
      }
    },
    _delTime() {
      this.value1 = []
      this._getPersons()
    },
    disabledDate(date) {
      const startTime = Cookies.get('startTime')
      const endTime = Cookies.get('nowTime')
      console.log(startTime, endTime)
      if (!startTime || !endTime) {
        return false
      }
      const startDate = new Date(startTime)
      const endDate = new Date(endTime)
      // 如果日期在范围内，则返回 false，否则返回 true
      return date < startDate || date > endDate
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-star;
  padding-top: 10px;
}

.row-in-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-top: 10px;
}

.el-card {
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: #007bff;
  box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: 200px;
  height: 240px;
  margin: 20px 20px;
}
</style>
